module.exports = __webpack_public_path__ + "static/media/28.562fd5ab.jpg";